<template>
	<div class="form__group">
		<multiselect
            :options="results"
            :placeholder="placeholder"
            :allow-empty="allowEmpty"
            label="name"
            track-by="id"
            :searchable="true"
            :loading="loading"
            :internal-search="false"
            :multiple="multiple"
            :options-limit="10"
            :show-labels="false"
            @search-change="onSearchChange"
            v-model="selected"
            :class="{ 'form__control': true, 'form__control--invalid': errors.first(this.name) }"
        >
			<span slot="noOptions">Type a name to search users...</span>
			<!-- Hide selection and show placeholder instead, since we are displaying the selection ourselves below -->
			<template v-slot:selection>
				<span class="multiselect__placeholder" v-if="selected && selected.length > 0">Select a user...</span>
			</template>
			<template v-slot:singleLabel>
				<span class="multiselect__placeholder" v-if="selected">Select a user...</span>
			</template>
		</multiselect>

        <template v-if="multiple && selected.length > 0">
			<div class="selected" v-if="selected" v-for="(user, index) in selected" :key="user.id">
				<img
                    v-if="user && user.avatar && user.id"
                    class="selected__avatar avatar avatar--small"
                    :src="`/images/avatar/${user.id}`"
                    alt=""
                />
				<span v-if="user">{{ user.name }}</span>
				<button class="selected__remove" type="button" @click.prevent="selected.splice(index, 1)">
					<SvgIcon icon="x"></SvgIcon>
				</button>
			</div>
		</template>

		<template v-else>
			<div class="selected" v-if="selected">
				<img class="selected__avatar avatar avatar--small" v-if="selected.avatar" :src="`/images/avatar/${selected.id}`" alt="">
				<span>{{ selected.name }}</span>
			</div>
		</template>

		<label class="form__label">{{ label }}</label>
		<div class="form__validation" slot="validation">{{ errors.first(this.name) }}</div>
	</div>
</template>

<script>
	import API from '@api';
	import AjaxSelect from './AjaxSelect';
	import SvgIcon from '../../SvgIcon';

	export default {
		name: 'FormControlUser',
		components: {SvgIcon},
		mixins: [AjaxSelect],
		props: {
			label: {
				type: String,
				default: 'Select user',
			},
			placeholder: {
				type: String,
				default: 'Select a user...',
			},
            defaultValue: {
                type: Object,
                default: null,
            }
		},
		methods: {
			search(query) {
				API.getUsers({
					query
				}).then(users => {
					this.results = users.data;
				}).finally(() => this.loading = false);
			},
			getItemFromCache(id) {
				return this.$store.getters['selectCache/getUser'](id);
			},
			addItemToCache(user) {
				this.$store.commit('selectCache/addUser', user);
			}
		},
        computed: {
            filteredSelected() {
                // remove null, undefined and empty strings from the selected array
                return this.selected.filter((item) => ![null, undefined, ''].includes(item));
            }
        },
	}
</script>

<style lang="scss" scoped>
	@import '~reflex-grid/scss/includes/variables';
	@import '~reflex-grid/scss/includes/mixins';
	@import '~@/theme/_variables.scss';
	@import '~@/mixins/_class.scss';
	@import '~@/theme/_extenables.scss';

	.selected {
		padding: 1rem 1rem 0 1rem;
		font-size: 1.2rem;
		line-height: 1.4rem;
		color: $link;
		@include display-flex;
		@include align-items(center);
		@include order(3);

		.selected__avatar {
			margin-right: 1rem;
			@include flex(0, 0, auto);
		}

		.selected__remove {
			appaerance: none;
			border: none;
			background: transparent;
			border-radius: 0;
			box-shadow: none;
			outline: none;
			padding: 0.5rem;
			margin-left: 0.5rem;
			cursor: pointer;
			color: $text;

			.svg-icon {
				width: 1.5rem;
				height: 1.5rem;
			}
		}
	}
</style>
